import { render, staticRenderFns } from "./channelPerfReport.vue?vue&type=template&id=28211e06"
import script from "./channelPerfReport.vue?vue&type=script&lang=js"
export * from "./channelPerfReport.vue?vue&type=script&lang=js"
import style0 from "./channelPerfReport.vue?vue&type=style&index=0&id=28211e06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports